class Description {
  constructor(description) {
    this.description = description;
  }

  toString() {
    return this.description;
  }
}

export default Description;
